import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { IconHome } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';

export function NotFound() {
  return (
    <Container size="sm" style={{ marginTop: '10vh' }}>
      <Stack gap="lg" align="center">
        <Title order={1} size="h1" style={{ fontSize: '6rem', fontWeight: 900 }}>
          404
        </Title>
        <Title order={2}>Page Not Found</Title>
        <Text size="lg" c="dimmed" ta="center">
          The page you're looking for doesn't exist or has been moved.
        </Text>
        <Button component={Link} to="/" leftSection={<IconHome size={18} />} size="lg">
          Return to Home
        </Button>
      </Stack>
    </Container>
  );
}
